import { render, staticRenderFns } from "./Scarcities.vue?vue&type=template&id=3543edc4&scoped=true&"
import script from "./Scarcities.vue?vue&type=script&lang=js&"
export * from "./Scarcities.vue?vue&type=script&lang=js&"
import style0 from "./Scarcities.vue?vue&type=style&index=0&id=3543edc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543edc4",
  null
  
)

export default component.exports